// extracted by mini-css-extract-plugin
export default {"glitterContainer":"style_glitterContainer__QLwdZ","glitter":"style_glitter__wg7Vs","sparkle":"style_sparkle__dyHWO","fall":"style_fall__WYfrA"};